"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roseCardHeader = exports.primaryCardHeader = exports.infoCardHeader = exports.dangerCardHeader = exports.successCardHeader = exports.warningCardHeader = exports.roseBoxShadow = exports.dangerBoxShadow = exports.warningBoxShadow = exports.successBoxShadow = exports.infoBoxShadow = exports.primaryBoxShadow = exports.coloredShadow = exports.container = void 0;
const config_1 = require("../../config/config");
const isIE = !!document.documentMode;
const containerIE = isIE
    ? {
        '@media (min-width: 576px)': {
            width: '540px'
        },
        '@media (min-width: 768px)': {
            width: '720px'
        },
        '@media (min-width: 992px)': {
            width: '960px'
        },
        '@media (min-width: 1200px)': {
            width: '1140px'
        }
    }
    : {};
const containerFluid = {
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%'
};
const container = Object.assign(Object.assign(Object.assign({}, containerFluid), containerIE), { '@media (min-width: 576px)': {
        maxWidth: '540px'
    }, '@media (min-width: 768px)': {
        maxWidth: '720px'
    }, '@media (min-width: 992px)': {
        maxWidth: '960px'
    }, '@media (min-width: 1200px)': {
        maxWidth: '1140px'
    } });
exports.container = container;
const coloredShadow = {
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        display: 'none !important'
    },
    transform: 'scale(0.94)',
    top: '12px',
    filter: 'blur(12px)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    zIndex: '-1',
    transition: 'opacity .45s',
    opacity: 0
};
exports.coloredShadow = coloredShadow;
const primaryBoxShadow = {
    boxShadow: `0 12px 20px -10px ${config_1.config.themeColors.primaryColor
        .alpha(0.28)
        .rgb()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${config_1.config.themeColors.primaryColor.alpha(0.2).rgb()}`
};
exports.primaryBoxShadow = primaryBoxShadow;
const infoBoxShadow = {
    boxShadow: `0 12px 20px -10px ${config_1.config.themeColors.infoColor
        .alpha(0.28)
        .rgb()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${config_1.config.themeColors.infoColor.alpha(0.2).rgb()}`
};
exports.infoBoxShadow = infoBoxShadow;
const successBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(31, 198, 150, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(31, 198, 150, 0.2)`
};
exports.successBoxShadow = successBoxShadow;
const warningBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)`
};
exports.warningBoxShadow = warningBoxShadow;
const dangerBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)`
};
exports.dangerBoxShadow = dangerBoxShadow;
const roseBoxShadow = {
    boxShadow: `0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)`
};
exports.roseBoxShadow = roseBoxShadow;
const warningCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #ffa726, #fb8c00)` }, warningBoxShadow);
exports.warningCardHeader = warningCardHeader;
const successCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #66bb6a, #43a047)` }, successBoxShadow);
exports.successCardHeader = successCardHeader;
const dangerCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #ef5350, #e53935)` }, dangerBoxShadow);
exports.dangerCardHeader = dangerCardHeader;
const infoCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #26c6da, #00acc1)` }, infoBoxShadow);
exports.infoCardHeader = infoCardHeader;
const primaryCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #ab47bc, #8e24aa)` }, primaryBoxShadow);
exports.primaryCardHeader = primaryCardHeader;
const roseCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #ec407a, #d81b60)` }, roseBoxShadow);
exports.roseCardHeader = roseCardHeader;
//# sourceMappingURL=general.js.map